module.exports = __webpack_public_path__ + "img/sixFace.dc7e5c3f.svg";